import React from "react";
import Page, { PageProps } from "../Page";
import DataGrid from "../../components/app/grid/DataGrid";
import { Form } from "antd";
import { IRuleGroupsPresenter } from "../../../presenter/evaluation/RuleGroupsPresenter";
import CreateRuleGroupForm, {
  CreateRuleGroupFormProps
} from "./CreateRuleGroupForm";
import UpdateRuleGroupForm, {
  UpdateRuleGroupFormProps
} from "./UpdateRuleGroupForm";
import Loader from "../../components/Loader";
export interface Props extends PageProps {}
export interface State extends IRuleGroupsPresenter {}

export default class RuleGroupsPage extends React.Component<Props, State> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe(result => {
      return this.setState(() => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    let {
      translate,
      ruleGroups = [],
      createRuleGroup,
      updateRuleGroup,
      getRuleGroupElements
    } = this.state;
    const CreateForm = Form.create<CreateRuleGroupFormProps>({})(
      CreateRuleGroupForm
    );

    const UpdateForm = Form.create<UpdateRuleGroupFormProps>({})(
      UpdateRuleGroupForm
    );

    const columns = [
      {
        title: translate("ruleGroups_page.name"),
        dataIndex: "name",
        key: "name"
      },
      {
        title: translate("ruleGroups_page.description"),
        dataIndex: "description",
        key: "description"
      },
      {
        title: translate("ruleGroups_page.weightThreshold"),
        key: "weightThreshold",
        dataIndex: "weightThreshold"
      }
    ];

    const dataGrid = (
      <DataGrid
        title={translate("grids.rule-groups")}
        translate={translate}
        columns={columns}
        dataSource={ruleGroups}
        allowCreate={true}
        allowDelete={false}
        allowUpdate={true}
        createForm={CreateForm}
        updateForm={UpdateForm}
        onCreate={createRuleGroup}
        onUpdate={updateRuleGroup}
        codebooks={getRuleGroupElements}
        createModalTitle={translate("ruleGroups_page.insert_modal_title")}
        updateModalTitle={translate("ruleGroups_page.update_modal_title")}
        addButtonText={translate("ruleGroups_page.add_button_text")}
      />
    );

    return (
      <Page {...this.props}>
        <Loader
          children={dataGrid}
          translate={translate}
          loading={this.state.loaders.ruleGroupsLoader}
        />
      </Page>
    );
  }
}
